import {useMachine} from '@xstate/vue'
import {createMachine, assign} from 'xstate'
import {shallowRef} from '@vue/reactivity'

const networkMachine = createMachine(
  {
    id: 'network',
    predictableActionArguments: true,
    type: 'parallel',
    context: {},
    states: {
      connectionNetwork: {
        initial: 'hidden',
        states: {
          hidden: {
            on: {
              LOST_CONNECTION: 'offline',
              ONLINE_CONNECTION: 'online',
            },
          },
          online: {
            on: {
              LOST_CONNECTION: 'offline',
              HIDDEN: 'hidden',
            },
            after: {
              3000: 'hidden',
            },
          },
          offline: {
            on: {
              ONLINE_CONNECTION: 'online',
              HIDDEN: 'hidden',
            },
          },
        },
      },
    },
  },
  {
    actions: {},
  }
)

const {state: machineState, send, service} = useMachine(networkMachine)
const state = shallowRef(machineState)
service.subscribe(_state => {
  console.info(`NetworkMachine received event ${_state.event.type}`, _state)
  state.value = _state
})

export default function () {
  return {state, send, service}
}
